import { Typography, Grid } from '@mui/material';
import { useIntl } from 'react-intl';

const SomethingWentWrong = () => {
  const intl = useIntl();

  return (
    <Grid
      container
      direction='column'
      alignItems='center'
      spacing={1}
      pt={20}
    >
      <Grid item>
        <Typography
          variant='h2'
          color='primary'
        >
          {intl.formatMessage({ id: 'apologies' })}
        </Typography>
      </Grid>
      <Grid item>
        <Typography variant='h6'>{intl.formatMessage({ id: 'somethingWentWrong' })}</Typography>
      </Grid>
      <Grid item>
        <Typography
          variant='h6'
          paragraph
        >
          {intl.formatMessage({ id: 'weAreWorkingOnIt' })}
        </Typography>
      </Grid>
    </Grid>
  );
};

export default SomethingWentWrong;
